export default __webpack_public_path__ + "./images/tw.05fa6fe1.svg";